module.exports = __webpack_public_path__ + "static/media/plavi-vjetar.019b2eec.png";